// extracted by mini-css-extract-plugin
module.exports = {"SignaturesContainer":"EventSignatures_SignaturesContainer__3hIuK"};